import type React from 'react';
import { useTokenRefresh } from '@/app/hooks/useTokenRefresh';

const TokenRefreshManager: React.FC = () => {
  useTokenRefresh();
  return null; // This component doesn't render anything
};

export default TokenRefreshManager;
